/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  PORTFOLIO DATA
  ============================================================

  Tämä tiedosto toimii lokaalissa samassa roolissa kuin
  WordPress REST API myöhemmin.

  React EI päätä:
  - kategorioita
  - kategorioiden nimiä
  - portfoliojuttujen tekstejä
  - portfoliojuttujen kategorioita
  - kuvia
  - järjestystä

  WordPress korvaa myöhemmin tämän datalähteen.
*/

const portfolioData = {
  labels: {
    all: {
      fi: "Kaikki",
      en: "All",
    },
  },

  categories: [
    {
      id: 1,
      slug: "weddings",
      name: {
        fi: "Häät",
        en: "Weddings",
      },
      enabled: true,
      order: 10,
    },

    {
      id: 2,
      slug: "couples",
      name: {
        fi: "Parit",
        en: "Couples",
      },
      enabled: true,
      order: 20,
    },

    {
      id: 3,
      slug: "portraits",
      name: {
        fi: "Henkilökuvat",
        en: "Portraits",
      },
      enabled: true,
      order: 30,
    },

    {
      id: 4,
      slug: "editorial",
      name: {
        fi: "Editorial",
        en: "Editorial",
      },
      enabled: true,
      order: 40,
    },

    {
      id: 5,
      slug: "products",
      name: {
        fi: "Tuotteet",
        en: "Products",
      },
      enabled: true,
      order: 50,
    },

    {
      id: 6,
      slug: "business",
      name: {
        fi: "Yritys & miljöö",
        en: "Business & Brand",
      },
      enabled: true,
      order: 60,
    },

    {
      id: 7,
      slug: "memorial",
      name: {
        fi: "Muistotilaisuudet",
        en: "Memorials",
      },
      enabled: true,
      order: 70,
    },

    {
      id: 8,
      slug: "seasonal",
      name: {
        fi: "Sesonki",
        en: "Seasonal",
      },
      enabled: true,
      order: 80,
    },
  ],

  items: [
    /*
      ==========================================================
      01 · WEDDINGS
      ==========================================================
    */

    {
      id: 101,
      slug: "wedding-story",
      categories: [
        "weddings",
      ],
      enabled: true,
      order: 10,

      content: {
        location: {
          fi: "Hääkuvaus",
          en: "Wedding photography",
        },

        title: {
          fi: "Päivä, joka jää.",
          en: "A day to remember.",
        },

        eyebrow: {
          fi: "Häät",
          en: "Weddings",
        },

        note: {
          fi:
            "Hääpäivä rakentuu suurista tunteista, pienistä yksityiskohdista ja hetkistä, joita ei voi suunnitella etukäteen.",
          en:
            "A wedding day is made of big emotions, small details and moments that could never be planned in advance.",
        },

        quote: {
          fi:
            "Kaikkea ei tarvitse muistaa itse.",
          en:
            "You do not have to remember everything yourself.",
        },

        supportAlt: {
          fi:
            "Hääpäivän kuvia",
          en:
            "Wedding day photographs",
        },
      },

      images: [
        {
          url:
            "/media/portfolio/wedding-01.webp",
          alt: {
            fi:
              "Hääpari läheisessä muotokuvassa",
            en:
              "Wedding couple in an intimate portrait",
          },
        },

        {
          url:
            "/media/portfolio/wedding-02.webp",
          alt: {
            fi:
              "Vihkisormukset kukkien vierellä",
            en:
              "Wedding rings beside flowers",
          },
        },

        {
          url:
            "/media/portfolio/wedding-03.webp",
          alt: {
            fi:
              "Hääpari kävelemässä rannalla",
            en:
              "Wedding couple walking on a beach",
          },
        },

        {
          url:
            "/media/portfolio/wedding-04.webp",
          alt: {
            fi:
              "Hääpari metsän keskellä",
            en:
              "Wedding couple surrounded by forest",
          },
        },
      ],
    },

    /*
      ==========================================================
      02 · COUPLES
      ==========================================================
    */

    {
      id: 102,
      slug: "couple-story",
      categories: [
        "couples",
      ],
      enabled: true,
      order: 20,

      content: {
        location: {
          fi: "Parikuvaus",
          en: "Couple photography",
        },

        title: {
          fi: "Kaksi ihmistä.",
          en: "Two people.",
        },

        eyebrow: {
          fi: "Parit",
          en: "Couples",
        },

        note: {
          fi:
            "Parikuvauksessa ei tarvitse osata poseerata. Riittää, että olette yhdessä ja annatte hetkien tapahtua.",
          en:
            "You do not need to know how to pose. Being together and letting the moments unfold is enough.",
        },

        quote: {
          fi:
            "Läheisyys näkyy pienissä asioissa.",
          en:
            "Connection lives in the smallest things.",
        },

        supportAlt: {
          fi:
            "Parikuvauksen kuvia",
          en:
            "Couple photography",
        },
      },

      images: [
        {
          url:
            "/media/portfolio/couple-01.webp",
          alt: {
            fi:
              "Pari kävelemässä kaupungilla",
            en:
              "Couple walking through the city",
          },
        },

        {
          url:
            "/media/portfolio/couple-02.webp",
          alt: {
            fi:
              "Pari läheisessä muotokuvassa",
            en:
              "Couple in an intimate portrait",
          },
        },

        {
          url:
            "/media/portfolio/couple-03.webp",
          alt: {
            fi:
              "Pari kävelemässä yhdessä puistossa",
            en:
              "Couple walking together in a park",
          },
        },

        {
          url:
            "/media/portfolio/couple-04.webp",
          alt: {
            fi:
              "Pari rannalla auringonlaskussa",
            en:
              "Couple on a beach at sunset",
          },
        },
      ],
    },

    /*
      ==========================================================
      03 · PORTRAITS
      ==========================================================
    */

    {
      id: 103,
      slug: "portrait-story",
      categories: [
        "portraits",
      ],
      enabled: true,
      order: 30,

      content: {
        location: {
          fi: "Henkilökuvaus",
          en: "Portrait photography",
        },

        title: {
          fi: "Sellaisena kuin olet.",
          en: "As you are.",
        },

        eyebrow: {
          fi: "Henkilökuvat",
          en: "Portraits",
        },

        note: {
          fi:
            "Hyvä henkilökuva ei tarvitse suurta elettä. Usein katse, valo ja pieni hetki riittävät.",
          en:
            "A strong portrait does not need a grand gesture. Often a look, the light and a quiet moment are enough.",
        },

        quote: {
          fi:
            "Muotokuva saa näyttää ihmiseltä, ei poseeraukselta.",
          en:
            "A portrait should feel like a person, not a pose.",
        },

        supportAlt: {
          fi:
            "Henkilökuvauksen kuvia",
          en:
            "Portrait photography",
        },
      },

      images: [
        {
          url:
            "/media/portfolio/portrait-01.webp",
          alt: {
            fi:
              "Naisen studiomuotokuva",
            en:
              "Studio portrait of a woman",
          },
        },

        {
          url:
            "/media/portfolio/portrait-02.webp",
          alt: {
            fi:
              "Vauvan luonnollinen muotokuva",
            en:
              "Natural portrait of a baby",
          },
        },

        {
          url:
            "/media/portfolio/portrait-03.webp",
          alt: {
            fi:
              "Henkilökuva ulkona luonnossa",
            en:
              "Environmental portrait outdoors",
          },
        },

        {
          url:
            "/media/portfolio/portrait-04.webp",
          alt: {
            fi:
              "Luonnollinen henkilökuva ulkona",
            en:
              "Natural outdoor portrait",
          },
        },
      ],
    },

    /*
      ==========================================================
      04 · EDITORIAL / BRANDING
      ==========================================================
    */

    {
      id: 104,
      slug: "editorial-brand",
      categories: [
        "editorial",
      ],
      enabled: true,
      order: 40,

      content: {
        location: {
          fi: "Editorial & brändikuvaus",
          en: "Editorial & branding",
        },

        title: {
          fi: "Kuva, jolla on asenne.",
          en: "An image with a point of view.",
        },

        eyebrow: {
          fi: "Editorial",
          en: "Editorial",
        },

        note: {
          fi:
            "Editorial- ja brändikuvauksessa rakennetaan kuvamaailma, joka tuntuu omalta ja kertoo enemmän kuin yksittäinen potretti.",
          en:
            "Editorial and branding photography builds a visual world that feels distinctive and communicates more than a single portrait.",
        },

        quote: {
          fi:
            "Brändi näkyy ennen kuin sitä ehditään selittää.",
          en:
            "A brand is seen before it is explained.",
        },

        supportAlt: {
          fi:
            "Editorial- ja brändikuvauksen kuvia",
          en:
            "Editorial and branding photography",
        },
      },

      images: [
        {
          url:
            "/media/portfolio/editorial-01.webp",
          alt: {
            fi:
              "Mustavalkoinen editorial-muotokuva",
            en:
              "Black and white editorial portrait",
          },
        },

        {
          url:
            "/media/portfolio/editorial-02.webp",
          alt: {
            fi:
              "Tyylitelty beauty-muotokuva",
            en:
              "Styled beauty portrait",
          },
        },

        {
          url:
            "/media/portfolio/editorial-03.webp",
          alt: {
            fi:
              "Lifestyle-henkinen brändikuva kahvilassa",
            en:
              "Lifestyle branding portrait in a café",
          },
        },

        {
          url:
            "/media/portfolio/editorial-04.webp",
          alt: {
            fi:
              "Työskentelyhetki kannettavan tietokoneen äärellä",
            en:
              "Creative professional working on a laptop",
          },
        },
      ],
    },

    /*
      ==========================================================
      05 · PRODUCTS
      ==========================================================
    */

    {
      id: 105,
      slug: "product-story",
      categories: [
        "products",
      ],
      enabled: true,
      order: 50,

      content: {
        location: {
          fi: "Tuotekuvaus",
          en: "Product photography",
        },

        title: {
          fi: "Muoto, valo ja materiaali.",
          en: "Form, light and material.",
        },

        eyebrow: {
          fi: "Tuotteet",
          en: "Products",
        },

        note: {
          fi:
            "Tuotekuva voi olla pelkistetty, ylellinen, tarinallinen tai tekninen. Tärkeintä on näyttää tuote tavalla, joka tukee sen omaa maailmaa.",
          en:
            "Product imagery can be minimal, luxurious, narrative or technical. What matters is presenting the product in a way that supports its own visual world.",
        },

        quote: {
          fi:
            "Yksityiskohta voi tehdä tuotteesta haluttavan.",
          en:
            "A single detail can make a product desirable.",
        },

        supportAlt: {
          fi:
            "Tuotekuvauksen kuvia",
          en:
            "Product photography",
        },
      },

      images: [
        {
          url:
            "/media/portfolio/product-01.webp",
          alt: {
            fi:
              "Mustat kengät tuotekuvauksessa",
            en:
              "Black shoes in a product photograph",
          },
        },

        {
          url:
            "/media/portfolio/product-02.webp",
          alt: {
            fi:
              "Hajuvesipullo tunnelmallisessa tuotekuvassa",
            en:
              "Perfume bottle in an atmospheric product image",
          },
        },

        {
          url:
            "/media/portfolio/product-03.webp",
          alt: {
            fi:
              "Kahvikuppi ja omenat asetelmassa",
            en:
              "Coffee cup and apples in a still life",
          },
        },

        {
          url:
            "/media/portfolio/product-04.webp",
          alt: {
            fi:
              "Älypuhelin teknisessä tuotekuvassa",
            en:
              "Smartphone in a technology product image",
          },
        },
      ],
    },

    /*
      ==========================================================
      06 · BUSINESS / BRAND
      ==========================================================
    */

    {
      id: 106,
      slug: "business-story",
      categories: [
        "business",
      ],
      enabled: true,
      order: 60,

      content: {
        location: {
          fi: "Yritys- ja miljöökuvaus",
          en: "Business & location photography",
        },

        title: {
          fi: "Työ näkyväksi.",
          en: "Make the work visible.",
        },

        eyebrow: {
          fi: "Yritys & miljöö",
          en: "Business & Brand",
        },

        note: {
          fi:
            "Yrityskuvauksessa ihminen, työ ja ympäristö rakentavat yhdessä kuvan siitä, kuka yrityksen takana on ja miltä sen maailma tuntuu.",
          en:
            "Business photography brings together people, work and environment to show who is behind the brand and what its world feels like.",
        },

        quote: {
          fi:
            "Parhaat yrityskuvat näyttävät, eivät selitä.",
          en:
            "The best brand photographs show rather than explain.",
        },

        supportAlt: {
          fi:
            "Yritys- ja miljöökuvauksen kuvia",
          en:
            "Business and location photography",
        },
      },

      images: [
        {
          url:
            "/media/portfolio/business-01.webp",
          alt: {
            fi:
              "Ammattilainen työssään",
            en:
              "Professional at work",
          },
        },

        {
          url:
            "/media/portfolio/business-02.webp",
          alt: {
            fi:
              "Yrittäjä työskentelemässä kannettavalla tietokoneella",
            en:
              "Entrepreneur working on a laptop",
          },
        },

        {
          url:
            "/media/portfolio/business-03.webp",
          alt: {
            fi:
              "Käsityöläisen kädet ja työvälineet",
            en:
              "Craftsperson's hands and tools",
          },
        },

        {
          url:
            "/media/portfolio/business-04.webp",
          alt: {
            fi:
              "Luova työtila luonnonvalossa",
            en:
              "Creative workspace in natural light",
          },
        },
      ],
    },

    /*
      ==========================================================
      07 · MEMORIALS
      ==========================================================
    */

    {
      id: 107,
      slug: "memorial-story",
      categories: [
        "memorial",
      ],
      enabled: true,
      order: 70,

      content: {
        location: {
          fi: "Muistotilaisuuskuvaus",
          en: "Memorial photography",
        },

        title: {
          fi: "Hiljaiset hetket.",
          en: "Quiet moments.",
        },

        eyebrow: {
          fi: "Muistotilaisuudet",
          en: "Memorials",
        },

        note: {
          fi:
            "Muistotilaisuuden kuvaaminen tehdään hienovaraisesti ja tilanteen arvoa kunnioittaen. Kuvissa voivat säilyä ihmiset, kukat, tila ja päivän pienet yksityiskohdat.",
          en:
            "Memorial photography is approached quietly and respectfully, preserving the people, flowers, surroundings and small details of the day.",
        },

        quote: {
          fi:
            "Myös hiljaiset hetket ovat säilyttämisen arvoisia.",
          en:
            "Quiet moments deserve to be remembered too.",
        },

        supportAlt: {
          fi:
            "Muistotilaisuuden kuvia",
          en:
            "Memorial photography",
        },
      },

      images: [
        {
          url:
            "/media/portfolio/memorial-01.webp",
          alt: {
            fi:
              "Palava kynttilä rauhallisessa tilassa",
            en:
              "Burning candle in a quiet setting",
          },
        },

        {
          url:
            "/media/portfolio/memorial-02.webp",
          alt: {
            fi:
              "Vaalea kukka-asetelma",
            en:
              "Soft floral arrangement",
          },
        },

        {
          url:
            "/media/portfolio/memorial-03.webp",
          alt: {
            fi:
              "Kirkon sisätila seremonian aikana",
            en:
              "Church interior during a ceremony",
          },
        },

        {
          url:
            "/media/portfolio/memorial-04.webp",
          alt: {
            fi:
              "Vaalea kukka-asetelma juhlapöydällä",
            en:
              "Light floral arrangement on a ceremonial table",
          },
        },
      ],
    },

    /*
      ==========================================================
      08 · SEASONAL
      ==========================================================
    */

    {
      id: 108,
      slug: "seasonal-story",
      categories: [
        "seasonal",
      ],
      enabled: true,
      order: 80,

      content: {
        location: {
          fi: "Sesonkikuvaus",
          en: "Seasonal photography",
        },

        title: {
          fi: "Vuoden omat hetket.",
          en: "Moments of the season.",
        },

        eyebrow: {
          fi: "Sesonki",
          en: "Seasonal",
        },

        note: {
          fi:
            "Joulukortit, talvipotretit ja muut sesonkikuvaukset tekevät vuoden pienistä perinteistä kuvia, joihin on mukava palata.",
          en:
            "Christmas cards, winter portraits and other seasonal sessions turn small annual traditions into photographs worth returning to.",
        },

        quote: {
          fi:
            "Perinteistä syntyy muistoja.",
          en:
            "Traditions become memories.",
        },

        supportAlt: {
          fi:
            "Joulu- ja sesonkikuvauksen kuvia",
          en:
            "Christmas and seasonal photography",
        },
      },

      images: [
        {
          url:
            "/media/portfolio/seasonal-01.webp",
          alt: {
            fi:
              "Punainen joulukoriste kuusen oksalla",
            en:
              "Red Christmas ornament on a tree",
          },
        },

        {
          url:
            "/media/portfolio/seasonal-02.webp",
          alt: {
            fi:
              "Lapsi joulukuusen äärellä",
            en:
              "Child beside a Christmas tree",
          },
        },

        {
          url:
            "/media/portfolio/seasonal-03.webp",
          alt: {
            fi:
              "Ystävät viettämässä joulua yhdessä",
            en:
              "Friends celebrating Christmas together",
          },
        },

        {
          url:
            "/media/portfolio/seasonal-04.webp",
          alt: {
            fi:
              "Talvinen henkilökuva lumisessa maisemassa",
            en:
              "Winter portrait in a snowy landscape",
          },
        },
      ],
    },
  ],
};

export default portfolioData;